import {
  FranchiseListResponseDTO,
  MasterFranchiseListResponseDTO
} from '../pages/franchises-list/types';
import {
  FranchiseBankAccountState,
  FranchiseState,
  MasterFranchiseState
} from '../types/FranchiseState';
import { get, post, put } from './request';

export const getFranchisesList = async (
  filter?: any
): Promise<FranchiseListResponseDTO> => {
  let response;
  let query = '';

  if (filter) {
    Object.entries(filter).forEach((map: [string, any]) => {
      if (map[1]) {
        query += `${map[0]}=${map[1]}&`;
      }
    });
  }

  try {
    response = await get(`/franchises?${query}`);
  } catch (e) {
    throw e;
  }

  return response;
};

export const getMasterFranchisesList = async (
  filter?: any
): Promise<MasterFranchiseListResponseDTO> => {
  let response;
  let query = '';

  if (filter) {
    Object.entries(filter).forEach((map: [string, any]) => {
      if (map[1]) {
        query += `${map[0]}=${map[1]}&`;
      }
    });
  }

  try {
    response = await get(`/master-franchises?${query}`);
  } catch (e) {
    console.log(e);
    throw e;
  }

  return response;
};

export const getAllFranchises = async (): Promise<FranchiseState[]> => {
  let response;
  try {
    response = await get(`/franchises/find-all`);
  } catch (e) {
    throw e;
  }

  return response;
};

export const getFranchiseById = async (id: string): Promise<FranchiseState> => {
  let response;
  try {
    response = await get(`/franchises/id/${id}`);
  } catch (e) {
    throw e;
  }

  return response;
};

export const getMasterFranchiseById = async (
  id: string
): Promise<MasterFranchiseState> => {
  let response;
  try {
    response = await get(`/master-franchises/id/${id}`);
  } catch (e) {
    throw e;
  }

  return response;
};

export const getFranchiseByLoggedUser = async (): Promise<FranchiseState> => {
  let response;
  try {
    response = await get(`/franchises/by-user`);
  } catch (e) {
    throw e;
  }

  return response;
};

export const getMasterFranchiseByLoggedUser = async (): Promise<MasterFranchiseState> => {
  let response;
  try {
    response = await get(`/master-franchises/by-user`);
  } catch (e) {
    throw e;
  }

  return response;
};

export const getBanks = async (): Promise<FranchiseBankAccountState[]> => {
  let response;
  try {
    response = await get(`/banks`);
  } catch (e) {
    throw e;
  }

  return response;
};

export const createFranchise = async (
  franchise: Partial<FranchiseState>
): Promise<FranchiseState> => {
  let response;
  try {
    response = await post(`/franchises`, franchise);
  } catch (e) {
    throw e;
  }

  return response;
};

export const createMasterFranchise = async (
  multiFranchise: MasterFranchiseState
): Promise<FranchiseState> => {
  let response;
  try {
    response = await post(`/master-franchises`, multiFranchise);
  } catch (e) {
    throw e;
  }

  return response;
};

export const updateFranchiseById = async (
  id: string,
  franchise: Partial<FranchiseState>
): Promise<FranchiseState> => {
  let response;
  try {
    response = await put(`/franchises/${id}`, franchise);
  } catch (e) {
    throw e;
  }

  return response;
};

export const updateMasterFranchiseById = async (
  id: string,
  multiFranchise: MasterFranchiseState
): Promise<MasterFranchiseState> => {
  let response;
  try {
    response = await put(`/master-franchises/${id}`, multiFranchise);
  } catch (e) {
    throw e;
  }

  return response;
};
